var toTopButton = document.getElementById("toTopButton");
window.addEventListener("scroll", function() {
    if (window.scrollY > 470) toTopButton.style.display = "block";
    else toTopButton.style.display = "none";
});

//# sourceMappingURL=index.6627b582.js.map
